var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNumber(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 347,
    viewBox: "0 0 87 347",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0349 0C25.5302 0 26.6622 0.630393 27.4308 1.89118C28.2134 3.13811 28.6047 4.95309 28.6047 7.33611C28.6047 9.71913 28.2134 11.541 27.4308 12.8018C26.6622 14.0626 25.5302 14.693 24.0349 14.693C22.5536 14.693 21.4216 14.0626 20.639 12.8018C19.8564 11.541 19.4651 9.71913 19.4651 7.33611C19.4651 4.96694 19.8564 3.15196 20.639 1.89118C21.4216 0.630393 22.5536 0 24.0349 0ZM20.9534 7.33611C20.9534 9.02639 21.1072 10.3495 21.4146 11.3055L26.0683 2.099C25.5791 1.44783 24.9013 1.12224 24.0349 1.12224C23.0706 1.12224 22.316 1.63487 21.771 2.66012C21.2259 3.67152 20.9534 5.23018 20.9534 7.33611ZM24.0349 13.55C25.0131 13.55 25.7748 13.0443 26.3198 12.0329C26.8648 11.0076 27.1373 9.44204 27.1373 7.33611C27.1373 5.54884 26.9627 4.16336 26.6133 3.17967L21.9596 12.4693C22.4627 13.1898 23.1545 13.55 24.0349 13.55Z",
    fill: "url(#paint0_linear_448_20)",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2926 37.1348H28.3741V38.2362H20.3874V37.1348H23.9511V25.4552L20.5551 27.4711L19.9682 26.5359L24.1607 23.9589H25.2926V37.1348Z",
    fill: "url(#paint1_linear_448_20)",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0349 47.5021C25.5302 47.5021 26.6622 48.1325 27.4308 49.3933C28.2134 50.6402 28.6047 52.4552 28.6047 54.8382C28.6047 57.2212 28.2134 59.0432 27.4308 60.3039C26.6622 61.5647 25.5302 62.1951 24.0349 62.1951C22.5536 62.1951 21.4216 61.5647 20.639 60.3039C19.8564 59.0432 19.4651 57.2212 19.4651 54.8382C19.4651 52.4691 19.8564 50.6541 20.639 49.3933C21.4216 48.1325 22.5536 47.5021 24.0349 47.5021ZM20.9534 54.8382C20.9534 56.5285 21.1072 57.8516 21.4146 58.8076L26.0683 49.6011C25.5791 48.9499 24.9013 48.6244 24.0349 48.6244C23.0706 48.6244 22.316 49.137 21.771 50.1622C21.2259 51.1736 20.9534 52.7323 20.9534 54.8382ZM24.0349 61.0521C25.0131 61.0521 25.7748 60.5464 26.3198 59.535C26.8648 58.5097 27.1373 56.9442 27.1373 54.8382C27.1373 53.051 26.9627 51.6655 26.6133 50.6818L21.9596 59.9714C22.4627 60.6919 23.1545 61.0521 24.0349 61.0521Z",
    fill: "url(#paint2_linear_448_20)",
    fillOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2926 84.6369H28.3741V85.7384H20.3874V84.6369H23.9511V72.9573L20.5551 74.9732L19.9682 74.038L24.1607 71.461H25.2926V84.6369Z",
    fill: "url(#paint3_linear_448_20)",
    fillOpacity: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2926 108.388H28.3741V109.489H20.3874V108.388H23.9511V96.7084L20.5551 98.7242L19.9682 97.789L24.1607 95.2121H25.2926V108.388Z",
    fill: "url(#paint4_linear_448_20)",
    fillOpacity: 0.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0349 118.755C25.5302 118.755 26.6622 119.386 27.4308 120.646C28.2134 121.893 28.6047 123.708 28.6047 126.091C28.6047 128.474 28.2134 130.296 27.4308 131.557C26.6622 132.818 25.5302 133.448 24.0349 133.448C22.5536 133.448 21.4216 132.818 20.639 131.557C19.8564 130.296 19.4651 128.474 19.4651 126.091C19.4651 123.722 19.8564 121.907 20.639 120.646C21.4216 119.386 22.5536 118.755 24.0349 118.755ZM20.9534 126.091C20.9534 127.782 21.1072 129.105 21.4146 130.061L26.0683 120.854C25.5791 120.203 24.9013 119.878 24.0349 119.878C23.0706 119.878 22.316 120.39 21.771 121.415C21.2259 122.427 20.9534 123.985 20.9534 126.091ZM24.0349 132.305C25.0131 132.305 25.7748 131.8 26.3198 130.788C26.8648 129.763 27.1373 128.197 27.1373 126.091C27.1373 124.304 26.9627 122.919 26.6133 121.935L21.9596 131.225C22.4627 131.945 23.1545 132.305 24.0349 132.305Z",
    fill: "url(#paint5_linear_448_20)",
    fillOpacity: 0.6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2926 155.89H28.3741V156.992H20.3874V155.89H23.9511V144.21L20.5551 146.226L19.9682 145.291L24.1607 142.714H25.2926V155.89Z",
    fill: "url(#paint6_linear_448_20)",
    fillOpacity: 0.6
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0349 166.257C25.5302 166.257 26.6622 166.888 27.4308 168.149C28.2134 169.396 28.6047 171.211 28.6047 173.594C28.6047 175.977 28.2134 177.798 27.4308 179.059C26.6622 180.32 25.5302 180.95 24.0349 180.95C22.5536 180.95 21.4216 180.32 20.639 179.059C19.8564 177.798 19.4651 175.977 19.4651 173.594C19.4651 171.224 19.8564 169.409 20.639 168.149C21.4216 166.888 22.5536 166.257 24.0349 166.257ZM20.9534 173.594C20.9534 175.284 21.1072 176.607 21.4146 177.563L26.0683 168.356C25.5791 167.705 24.9013 167.38 24.0349 167.38C23.0706 167.38 22.316 167.892 21.771 168.918C21.2259 169.929 20.9534 171.488 20.9534 173.594ZM24.0349 179.807C25.0131 179.807 25.7748 179.302 26.3198 178.29C26.8648 177.265 27.1373 175.699 27.1373 173.594C27.1373 171.806 26.9627 170.421 26.6133 169.437L21.9596 178.727C22.4627 179.447 23.1545 179.807 24.0349 179.807Z",
    fill: "url(#paint7_linear_448_20)",
    fillOpacity: 0.6
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0349 190.008C25.5302 190.008 26.6622 190.639 27.4308 191.9C28.2134 193.147 28.6047 194.962 28.6047 197.345C28.6047 199.728 28.2134 201.549 27.4308 202.81C26.6622 204.071 25.5302 204.701 24.0349 204.701C22.5536 204.701 21.4216 204.071 20.639 202.81C19.8564 201.549 19.4651 199.728 19.4651 197.345C19.4651 194.975 19.8564 193.16 20.639 191.9C21.4216 190.639 22.5536 190.008 24.0349 190.008ZM20.9534 197.345C20.9534 199.035 21.1072 200.358 21.4146 201.314L26.0683 192.107C25.5791 191.456 24.9013 191.131 24.0349 191.131C23.0706 191.131 22.316 191.643 21.771 192.669C21.2259 193.68 20.9534 195.239 20.9534 197.345ZM24.0349 203.558C25.0131 203.558 25.7748 203.053 26.3198 202.041C26.8648 201.016 27.1373 199.451 27.1373 197.345C27.1373 195.557 26.9627 194.172 26.6133 193.188L21.9596 202.478C22.4627 203.198 23.1545 203.558 24.0349 203.558Z",
    fill: "url(#paint8_linear_448_20)",
    fillOpacity: 0.6
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2926 227.143H28.3741V228.245H20.3874V227.143H23.9511V215.464L20.5551 217.48L19.9682 216.544L24.1607 213.967H25.2926V227.143Z",
    fill: "url(#paint9_linear_448_20)",
    fillOpacity: 0.6
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0349 237.511C25.5302 237.511 26.6622 238.141 27.4308 239.402C28.2134 240.649 28.6047 242.464 28.6047 244.847C28.6047 247.23 28.2134 249.052 27.4308 250.312C26.6622 251.573 25.5302 252.204 24.0349 252.204C22.5536 252.204 21.4216 251.573 20.639 250.312C19.8564 249.052 19.4651 247.23 19.4651 244.847C19.4651 242.478 19.8564 240.663 20.639 239.402C21.4216 238.141 22.5536 237.511 24.0349 237.511ZM20.9534 244.847C20.9534 246.537 21.1072 247.86 21.4146 248.816L26.0683 239.61C25.5791 238.958 24.9013 238.633 24.0349 238.633C23.0706 238.633 22.316 239.145 21.771 240.171C21.2259 241.182 20.9534 242.741 20.9534 244.847ZM24.0349 251.061C25.0131 251.061 25.7748 250.555 26.3198 249.543C26.8648 248.518 27.1373 246.953 27.1373 244.847C27.1373 243.059 26.9627 241.674 26.6133 240.69L21.9596 249.98C22.4627 250.7 23.1545 251.061 24.0349 251.061Z",
    fill: "url(#paint10_linear_448_20)",
    fillOpacity: 0.6
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2926 274.645H28.3741V275.747H20.3874V274.645H23.9511V262.966L20.5551 264.982L19.9682 264.046L24.1607 261.469H25.2926V274.645Z",
    fill: "url(#paint11_linear_448_20)",
    fillOpacity: 0.6
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2926 298.396H28.3741V299.498H20.3874V298.396H23.9511V286.717L20.5551 288.733L19.9682 287.798L24.1607 285.221H25.2926V298.396Z",
    fill: "url(#paint12_linear_448_20)",
    fillOpacity: 0.6
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9651 47.5021C64.4604 47.5021 65.5924 48.1325 66.361 49.3933C67.1436 50.6402 67.5349 52.4552 67.5349 54.8382C67.5349 57.2212 67.1436 59.0432 66.361 60.3039C65.5924 61.5647 64.4604 62.1951 62.9651 62.1951C61.4838 62.1951 60.3518 61.5647 59.5692 60.3039C58.7866 59.0432 58.3953 57.2212 58.3953 54.8382C58.3953 52.4691 58.7866 50.6541 59.5692 49.3933C60.3518 48.1325 61.4838 47.5021 62.9651 47.5021ZM59.8836 54.8382C59.8836 56.5285 60.0374 57.8516 60.3448 58.8076L64.9985 49.6011C64.5093 48.9499 63.8315 48.6244 62.9651 48.6244C62.0008 48.6244 61.2462 49.137 60.7012 50.1622C60.1561 51.1736 59.8836 52.7323 59.8836 54.8382ZM62.9651 61.0521C63.9433 61.0521 64.705 60.5464 65.25 59.535C65.795 58.5097 66.0675 56.9442 66.0675 54.8382C66.0675 53.051 65.8928 51.6655 65.5435 50.6818L60.8898 59.9714C61.3929 60.6919 62.0847 61.0521 62.9651 61.0521Z",
    fill: "url(#paint13_linear_448_20)",
    fillOpacity: 0.6
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2228 84.6369H67.3043V85.7384H59.3176V84.6369H62.8812V72.9573L59.4853 74.9732L58.8984 74.038L63.0909 71.461H64.2228V84.6369Z",
    fill: "url(#paint14_linear_448_20)",
    fillOpacity: 0.6
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9651 95.0042C64.4604 95.0042 65.5924 95.6346 66.361 96.8954C67.1436 98.1423 67.5349 99.9573 67.5349 102.34C67.5349 104.723 67.1436 106.545 66.361 107.806C65.5924 109.067 64.4604 109.697 62.9651 109.697C61.4838 109.697 60.3518 109.067 59.5692 107.806C58.7866 106.545 58.3953 104.723 58.3953 102.34C58.3953 99.9712 58.7866 98.1562 59.5692 96.8954C60.3518 95.6346 61.4838 95.0042 62.9651 95.0042ZM59.8836 102.34C59.8836 104.031 60.0374 105.354 60.3448 106.31L64.9985 97.1032C64.5093 96.4521 63.8315 96.1265 62.9651 96.1265C62.0008 96.1265 61.2462 96.6391 60.7012 97.6644C60.1561 98.6758 59.8836 100.234 59.8836 102.34ZM62.9651 108.554C63.9433 108.554 64.705 108.049 65.25 107.037C65.795 106.012 66.0675 104.446 66.0675 102.34C66.0675 100.553 65.8928 99.1676 65.5435 98.1839L60.8898 107.474C61.3929 108.194 62.0847 108.554 62.9651 108.554Z",
    fill: "url(#paint15_linear_448_20)",
    fillOpacity: 0.6
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9651 118.755C64.4604 118.755 65.5924 119.386 66.361 120.646C67.1436 121.893 67.5349 123.708 67.5349 126.091C67.5349 128.474 67.1436 130.296 66.361 131.557C65.5924 132.818 64.4604 133.448 62.9651 133.448C61.4838 133.448 60.3518 132.818 59.5692 131.557C58.7866 130.296 58.3953 128.474 58.3953 126.091C58.3953 123.722 58.7866 121.907 59.5692 120.646C60.3518 119.386 61.4838 118.755 62.9651 118.755ZM59.8836 126.091C59.8836 127.782 60.0374 129.105 60.3448 130.061L64.9985 120.854C64.5093 120.203 63.8315 119.878 62.9651 119.878C62.0008 119.878 61.2462 120.39 60.7012 121.415C60.1561 122.427 59.8836 123.985 59.8836 126.091ZM62.9651 132.305C63.9433 132.305 64.705 131.8 65.25 130.788C65.795 129.763 66.0675 128.197 66.0675 126.091C66.0675 124.304 65.8928 122.919 65.5435 121.935L60.8898 131.225C61.3929 131.945 62.0847 132.305 62.9651 132.305Z",
    fill: "url(#paint16_linear_448_20)",
    fillOpacity: 0.6
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2228 155.89H67.3043V156.992H59.3176V155.89H62.8812V144.21L59.4853 146.226L58.8984 145.291L63.0909 142.714H64.2228V155.89Z",
    fill: "url(#paint17_linear_448_20)",
    fillOpacity: 0.6
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9651 166.257C64.4604 166.257 65.5924 166.888 66.361 168.149C67.1436 169.396 67.5349 171.211 67.5349 173.594C67.5349 175.977 67.1436 177.798 66.361 179.059C65.5924 180.32 64.4604 180.95 62.9651 180.95C61.4838 180.95 60.3518 180.32 59.5692 179.059C58.7866 177.798 58.3953 175.977 58.3953 173.594C58.3953 171.224 58.7866 169.409 59.5692 168.149C60.3518 166.888 61.4838 166.257 62.9651 166.257ZM59.8836 173.594C59.8836 175.284 60.0374 176.607 60.3448 177.563L64.9985 168.356C64.5093 167.705 63.8315 167.38 62.9651 167.38C62.0008 167.38 61.2462 167.892 60.7012 168.918C60.1561 169.929 59.8836 171.488 59.8836 173.594ZM62.9651 179.807C63.9433 179.807 64.705 179.302 65.25 178.29C65.795 177.265 66.0675 175.699 66.0675 173.594C66.0675 171.806 65.8928 170.421 65.5435 169.437L60.8898 178.727C61.3929 179.447 62.0847 179.807 62.9651 179.807Z",
    fill: "url(#paint18_linear_448_20)",
    fillOpacity: 0.6
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2228 203.392H67.3043V204.494H59.3176V203.392H62.8812V191.713L59.4853 193.728L58.8984 192.793L63.0909 190.216H64.2228V203.392Z",
    fill: "url(#paint19_linear_448_20)",
    fillOpacity: 0.6
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9651 213.76C64.4604 213.76 65.5924 214.39 66.361 215.651C67.1436 216.898 67.5349 218.713 67.5349 221.096C67.5349 223.479 67.1436 225.301 66.361 226.561C65.5924 227.822 64.4604 228.453 62.9651 228.453C61.4838 228.453 60.3518 227.822 59.5692 226.561C58.7866 225.301 58.3953 223.479 58.3953 221.096C58.3953 218.726 58.7866 216.911 59.5692 215.651C60.3518 214.39 61.4838 213.76 62.9651 213.76ZM59.8836 221.096C59.8836 222.786 60.0374 224.109 60.3448 225.065L64.9985 215.859C64.5093 215.207 63.8315 214.882 62.9651 214.882C62.0008 214.882 61.2462 215.394 60.7012 216.42C60.1561 217.431 59.8836 218.99 59.8836 221.096ZM62.9651 227.31C63.9433 227.31 64.705 226.804 65.25 225.792C65.795 224.767 66.0675 223.202 66.0675 221.096C66.0675 219.308 65.8928 217.923 65.5435 216.939L60.8898 226.229C61.3929 226.949 62.0847 227.31 62.9651 227.31Z",
    fill: "url(#paint20_linear_448_20)",
    fillOpacity: 0.6
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9651 237.511C64.4604 237.511 65.5924 238.141 66.361 239.402C67.1436 240.649 67.5349 242.464 67.5349 244.847C67.5349 247.23 67.1436 249.052 66.361 250.312C65.5924 251.573 64.4604 252.204 62.9651 252.204C61.4838 252.204 60.3518 251.573 59.5692 250.312C58.7866 249.052 58.3953 247.23 58.3953 244.847C58.3953 242.478 58.7866 240.663 59.5692 239.402C60.3518 238.141 61.4838 237.511 62.9651 237.511ZM59.8836 244.847C59.8836 246.537 60.0374 247.86 60.3448 248.816L64.9985 239.61C64.5093 238.958 63.8315 238.633 62.9651 238.633C62.0008 238.633 61.2462 239.145 60.7012 240.171C60.1561 241.182 59.8836 242.741 59.8836 244.847ZM62.9651 251.061C63.9433 251.061 64.705 250.555 65.25 249.543C65.795 248.518 66.0675 246.953 66.0675 244.847C66.0675 243.059 65.8928 241.674 65.5435 240.69L60.8898 249.98C61.3929 250.7 62.0847 251.061 62.9651 251.061Z",
    fill: "url(#paint21_linear_448_20)",
    fillOpacity: 0.6
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2228 274.645H67.3043V275.747H59.3176V274.645H62.8812V262.966L59.4853 264.982L58.8984 264.046L63.0909 261.469H64.2228V274.645Z",
    fill: "url(#paint22_linear_448_20)",
    fillOpacity: 0.6
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9651 285.013C64.4604 285.013 65.5924 285.643 66.361 286.904C67.1436 288.151 67.5349 289.966 67.5349 292.349C67.5349 294.732 67.1436 296.554 66.361 297.815C65.5924 299.075 64.4604 299.706 62.9651 299.706C61.4838 299.706 60.3518 299.075 59.5692 297.815C58.7866 296.554 58.3953 294.732 58.3953 292.349C58.3953 289.98 58.7866 288.165 59.5692 286.904C60.3518 285.643 61.4838 285.013 62.9651 285.013ZM59.8836 292.349C59.8836 294.039 60.0374 295.362 60.3448 296.318L64.9985 287.112C64.5093 286.461 63.8315 286.135 62.9651 286.135C62.0008 286.135 61.2462 286.648 60.7012 287.673C60.1561 288.684 59.8836 290.243 59.8836 292.349ZM62.9651 298.563C63.9433 298.563 64.705 298.057 65.25 297.046C65.795 296.02 66.0675 294.455 66.0675 292.349C66.0675 290.562 65.8928 289.176 65.5435 288.192L60.8898 297.482C61.3929 298.202 62.0847 298.563 62.9651 298.563Z",
    fill: "url(#paint23_linear_448_20)",
    fillOpacity: 0.6
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2228 322.147H67.3043V323.249H59.3176V322.147H62.8812V310.468L59.4853 312.484L58.8984 311.549L63.0909 308.972H64.2228V322.147Z",
    fill: "url(#paint24_linear_448_20)",
    fillOpacity: 0.6
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2228 345.899H67.3043V347H59.3176V345.899H62.8812V334.219L59.4853 336.235L58.8984 335.3L63.0909 332.723H64.2228V345.899Z",
    fill: "url(#paint25_linear_448_20)",
    fillOpacity: 0.6
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M4.56981 71.2532C6.06512 71.2532 7.1971 71.8836 7.96572 73.1444C8.74831 74.3913 9.13961 76.2063 9.13961 78.5893C9.13961 80.9723 8.74831 82.7942 7.96572 84.055C7.1971 85.3158 6.06512 85.9462 4.56981 85.9462C3.08846 85.9462 1.95649 85.3158 1.1739 84.055C0.391299 82.7942 0 80.9723 0 78.5893C0 76.2201 0.391299 74.4051 1.1739 73.1444C1.95649 71.8836 3.08846 71.2532 4.56981 71.2532ZM1.48833 78.5893C1.48833 80.2796 1.64206 81.6027 1.9495 82.5587L6.60316 73.3522C6.11404 72.701 5.43625 72.3754 4.56981 72.3754C3.60553 72.3754 2.85089 72.888 2.30587 73.9133C1.76084 74.9247 1.48833 76.4834 1.48833 78.5893ZM4.56981 84.8032C5.54805 84.8032 6.30969 84.2974 6.85471 83.286C7.39973 82.2608 7.67224 80.6952 7.67224 78.5893C7.67224 76.802 7.49756 75.4165 7.14818 74.4328L2.49453 83.7225C2.99763 84.4429 3.68938 84.8032 4.56981 84.8032Z",
    fill: "url(#paint26_linear_448_20)",
    fillOpacity: 0.6
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M4.56981 95.0042C6.06512 95.0042 7.1971 95.6346 7.96572 96.8954C8.74831 98.1423 9.13961 99.9573 9.13961 102.34C9.13961 104.723 8.74831 106.545 7.96572 107.806C7.1971 109.067 6.06512 109.697 4.56981 109.697C3.08846 109.697 1.95649 109.067 1.1739 107.806C0.391299 106.545 0 104.723 0 102.34C0 99.9712 0.391299 98.1562 1.1739 96.8954C1.95649 95.6346 3.08846 95.0042 4.56981 95.0042ZM1.48833 102.34C1.48833 104.031 1.64206 105.354 1.9495 106.31L6.60316 97.1032C6.11404 96.4521 5.43625 96.1265 4.56981 96.1265C3.60553 96.1265 2.85089 96.6391 2.30587 97.6644C1.76084 98.6758 1.48833 100.234 1.48833 102.34ZM4.56981 108.554C5.54805 108.554 6.30969 108.049 6.85471 107.037C7.39973 106.012 7.67224 104.446 7.67224 102.34C7.67224 100.553 7.49756 99.1676 7.14818 98.1839L2.49453 107.474C2.99763 108.194 3.68938 108.554 4.56981 108.554Z",
    fill: "url(#paint27_linear_448_20)",
    fillOpacity: 0.6
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M5.82755 132.139H8.90903V133.24H0.922346V132.139H4.48596V120.459L1.09005 122.475L0.503098 121.54L4.69558 118.963H5.82755V132.139Z",
    fill: "url(#paint28_linear_448_20)",
    fillOpacity: 0.6
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M4.56981 142.506C6.06512 142.506 7.1971 143.137 7.96572 144.398C8.74831 145.644 9.13961 147.459 9.13961 149.842C9.13961 152.225 8.74831 154.047 7.96572 155.308C7.1971 156.569 6.06512 157.199 4.56981 157.199C3.08846 157.199 1.95649 156.569 1.1739 155.308C0.391299 154.047 0 152.225 0 149.842C0 147.473 0.391299 145.658 1.1739 144.398C1.95649 143.137 3.08846 142.506 4.56981 142.506ZM1.48833 149.842C1.48833 151.533 1.64206 152.856 1.9495 153.812L6.60316 144.605C6.11404 143.954 5.43625 143.629 4.56981 143.629C3.60553 143.629 2.85089 144.141 2.30587 145.166C1.76084 146.178 1.48833 147.737 1.48833 149.842ZM4.56981 156.056C5.54805 156.056 6.30969 155.551 6.85471 154.539C7.39973 153.514 7.67224 151.948 7.67224 149.842C7.67224 148.055 7.49756 146.67 7.14818 145.686L2.49453 154.976C2.99763 155.696 3.68938 156.056 4.56981 156.056Z",
    fill: "url(#paint29_linear_448_20)",
    fillOpacity: 0.6
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M5.82755 179.641H8.90903V180.743H0.922346V179.641H4.48596V167.962L1.09005 169.977L0.503098 169.042L4.69558 166.465H5.82755V179.641Z",
    fill: "url(#paint30_linear_448_20)",
    fillOpacity: 0.6
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M5.82755 203.392H8.90903V204.494H0.922346V203.392H4.48596V191.713L1.09005 193.728L0.503098 192.793L4.69558 190.216H5.82755V203.392Z",
    fill: "url(#paint31_linear_448_20)",
    fillOpacity: 0.6
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7577 37.1348H47.8392V38.2362H39.8525V37.1348H43.4162V25.4552L40.0202 27.4711L39.4333 26.5359L43.6258 23.9589H44.7577V37.1348Z",
    fill: "url(#paint32_linear_448_20)",
    fillOpacity: 0.6
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5 47.5021C44.9953 47.5021 46.1273 48.1325 46.8959 49.3933C47.6785 50.6402 48.0698 52.4552 48.0698 54.8382C48.0698 57.2212 47.6785 59.0432 46.8959 60.3039C46.1273 61.5647 44.9953 62.1951 43.5 62.1951C42.0187 62.1951 40.8867 61.5647 40.1041 60.3039C39.3215 59.0432 38.9302 57.2212 38.9302 54.8382C38.9302 52.4691 39.3215 50.6541 40.1041 49.3933C40.8867 48.1325 42.0187 47.5021 43.5 47.5021ZM40.4185 54.8382C40.4185 56.5285 40.5723 57.8516 40.8797 58.8076L45.5334 49.6011C45.0442 48.9499 44.3664 48.6244 43.5 48.6244C42.5357 48.6244 41.7811 49.137 41.2361 50.1622C40.691 51.1736 40.4185 52.7323 40.4185 54.8382ZM43.5 61.0521C44.4782 61.0521 45.2399 60.5464 45.7849 59.535C46.3299 58.5097 46.6024 56.9442 46.6024 54.8382C46.6024 53.051 46.4277 51.6655 46.0784 50.6818L41.4247 59.9714C41.9278 60.6919 42.6196 61.0521 43.5 61.0521Z",
    fill: "url(#paint33_linear_448_20)",
    fillOpacity: 0.6
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7577 84.6369H47.8392V85.7384H39.8525V84.6369H43.4162V72.9573L40.0202 74.9732L39.4333 74.038L43.6258 71.461H44.7577V84.6369Z",
    fill: "url(#paint34_linear_448_20)",
    fillOpacity: 0.6
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7577 108.388H47.8392V109.489H39.8525V108.388H43.4162V96.7084L40.0202 98.7242L39.4333 97.789L43.6258 95.2121H44.7577V108.388Z",
    fill: "url(#paint35_linear_448_20)",
    fillOpacity: 0.6
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5 118.755C44.9953 118.755 46.1273 119.386 46.8959 120.646C47.6785 121.893 48.0698 123.708 48.0698 126.091C48.0698 128.474 47.6785 130.296 46.8959 131.557C46.1273 132.818 44.9953 133.448 43.5 133.448C42.0187 133.448 40.8867 132.818 40.1041 131.557C39.3215 130.296 38.9302 128.474 38.9302 126.091C38.9302 123.722 39.3215 121.907 40.1041 120.646C40.8867 119.386 42.0187 118.755 43.5 118.755ZM40.4185 126.091C40.4185 127.782 40.5723 129.105 40.8797 130.061L45.5334 120.854C45.0442 120.203 44.3664 119.878 43.5 119.878C42.5357 119.878 41.7811 120.39 41.2361 121.415C40.691 122.427 40.4185 123.985 40.4185 126.091ZM43.5 132.305C44.4782 132.305 45.2399 131.8 45.7849 130.788C46.3299 129.763 46.6024 128.197 46.6024 126.091C46.6024 124.304 46.4277 122.919 46.0784 121.935L41.4247 131.225C41.9278 131.945 42.6196 132.305 43.5 132.305Z",
    fill: "url(#paint36_linear_448_20)",
    fillOpacity: 0.6
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7577 155.89H47.8392V156.992H39.8525V155.89H43.4162V144.21L40.0202 146.226L39.4333 145.291L43.6258 142.714H44.7577V155.89Z",
    fill: "url(#paint37_linear_448_20)",
    fillOpacity: 0.6
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7577 179.641H47.8392V180.743H39.8525V179.641H43.4162V167.962L40.0202 169.977L39.4333 169.042L43.6258 166.465H44.7577V179.641Z",
    fill: "url(#paint38_linear_448_20)",
    fillOpacity: 0.6
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5 190.008C44.9953 190.008 46.1273 190.639 46.8959 191.9C47.6785 193.147 48.0698 194.962 48.0698 197.345C48.0698 199.728 47.6785 201.549 46.8959 202.81C46.1273 204.071 44.9953 204.701 43.5 204.701C42.0187 204.701 40.8867 204.071 40.1041 202.81C39.3215 201.549 38.9302 199.728 38.9302 197.345C38.9302 194.975 39.3215 193.16 40.1041 191.9C40.8867 190.639 42.0187 190.008 43.5 190.008ZM40.4185 197.345C40.4185 199.035 40.5723 200.358 40.8797 201.314L45.5334 192.107C45.0442 191.456 44.3664 191.131 43.5 191.131C42.5357 191.131 41.7811 191.643 41.2361 192.669C40.691 193.68 40.4185 195.239 40.4185 197.345ZM43.5 203.558C44.4782 203.558 45.2399 203.053 45.7849 202.041C46.3299 201.016 46.6024 199.451 46.6024 197.345C46.6024 195.557 46.4277 194.172 46.0784 193.188L41.4247 202.478C41.9278 203.198 42.6196 203.558 43.5 203.558Z",
    fill: "url(#paint39_linear_448_20)",
    fillOpacity: 0.6
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7577 227.143H47.8392V228.245H39.8525V227.143H43.4162V215.464L40.0202 217.48L39.4333 216.544L43.6258 213.967H44.7577V227.143Z",
    fill: "url(#paint40_linear_448_20)",
    fillOpacity: 0.6
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5 237.511C44.9953 237.511 46.1273 238.141 46.8959 239.402C47.6785 240.649 48.0698 242.464 48.0698 244.847C48.0698 247.23 47.6785 249.052 46.8959 250.312C46.1273 251.573 44.9953 252.204 43.5 252.204C42.0187 252.204 40.8867 251.573 40.1041 250.312C39.3215 249.052 38.9302 247.23 38.9302 244.847C38.9302 242.478 39.3215 240.663 40.1041 239.402C40.8867 238.141 42.0187 237.511 43.5 237.511ZM40.4185 244.847C40.4185 246.537 40.5723 247.86 40.8797 248.816L45.5334 239.61C45.0442 238.958 44.3664 238.633 43.5 238.633C42.5357 238.633 41.7811 239.145 41.2361 240.171C40.691 241.182 40.4185 242.741 40.4185 244.847ZM43.5 251.061C44.4782 251.061 45.2399 250.555 45.7849 249.543C46.3299 248.518 46.6024 246.953 46.6024 244.847C46.6024 243.059 46.4277 241.674 46.0784 240.69L41.4247 249.98C41.9278 250.7 42.6196 251.061 43.5 251.061Z",
    fill: "url(#paint41_linear_448_20)",
    fillOpacity: 0.6
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4302 23.7511C83.9255 23.7511 85.0575 24.3815 85.8261 25.6422C86.6087 26.8892 87 28.7041 87 31.0872C87 33.4702 86.6087 35.2921 85.8261 36.5529C85.0575 37.8137 83.9255 38.4441 82.4302 38.4441C80.9489 38.4441 79.8169 37.8137 79.0343 36.5529C78.2517 35.2921 77.8604 33.4702 77.8604 31.0872C77.8604 28.718 78.2517 26.903 79.0343 25.6422C79.8169 24.3815 80.9489 23.7511 82.4302 23.7511ZM79.3487 31.0872C79.3487 32.7775 79.5024 34.1006 79.8099 35.0566L84.4636 25.8501C83.9744 25.1989 83.2966 24.8733 82.4302 24.8733C81.4659 24.8733 80.7113 25.3859 80.1663 26.4112C79.6212 27.4226 79.3487 28.9812 79.3487 31.0872ZM82.4302 37.301C83.4084 37.301 84.1701 36.7953 84.7151 35.7839C85.2601 34.7587 85.5326 33.1931 85.5326 31.0872C85.5326 29.2999 85.3579 27.9144 85.0086 26.9307L80.3549 36.2204C80.858 36.9408 81.5498 37.301 82.4302 37.301Z",
    fill: "url(#paint42_linear_448_20)",
    fillOpacity: 0.6
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6879 60.8858H86.7694V61.9873H78.7827V60.8858H82.3463V49.2063L78.9504 51.2221L78.3635 50.2869L82.556 47.7099H83.6879V60.8858Z",
    fill: "url(#paint43_linear_448_20)",
    fillOpacity: 0.6
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6879 84.6369H86.7694V85.7384H78.7827V84.6369H82.3463V72.9573L78.9504 74.9732L78.3635 74.038L82.556 71.461H83.6879V84.6369Z",
    fill: "url(#paint44_linear_448_20)",
    fillOpacity: 0.6
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4302 95.0042C83.9255 95.0042 85.0575 95.6346 85.8261 96.8954C86.6087 98.1423 87 99.9573 87 102.34C87 104.723 86.6087 106.545 85.8261 107.806C85.0575 109.067 83.9255 109.697 82.4302 109.697C80.9489 109.697 79.8169 109.067 79.0343 107.806C78.2517 106.545 77.8604 104.723 77.8604 102.34C77.8604 99.9712 78.2517 98.1562 79.0343 96.8954C79.8169 95.6346 80.9489 95.0042 82.4302 95.0042ZM79.3487 102.34C79.3487 104.031 79.5024 105.354 79.8099 106.31L84.4636 97.1032C83.9744 96.4521 83.2966 96.1265 82.4302 96.1265C81.4659 96.1265 80.7113 96.6391 80.1663 97.6644C79.6212 98.6758 79.3487 100.234 79.3487 102.34ZM82.4302 108.554C83.4084 108.554 84.1701 108.049 84.7151 107.037C85.2601 106.012 85.5326 104.446 85.5326 102.34C85.5326 100.553 85.3579 99.1676 85.0086 98.1839L80.3549 107.474C80.858 108.194 81.5498 108.554 82.4302 108.554Z",
    fill: "url(#paint45_linear_448_20)",
    fillOpacity: 0.6
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4302 118.755C83.9255 118.755 85.0575 119.386 85.8261 120.646C86.6087 121.893 87 123.708 87 126.091C87 128.474 86.6087 130.296 85.8261 131.557C85.0575 132.818 83.9255 133.448 82.4302 133.448C80.9489 133.448 79.8169 132.818 79.0343 131.557C78.2517 130.296 77.8604 128.474 77.8604 126.091C77.8604 123.722 78.2517 121.907 79.0343 120.646C79.8169 119.386 80.9489 118.755 82.4302 118.755ZM79.3487 126.091C79.3487 127.782 79.5024 129.105 79.8099 130.061L84.4636 120.854C83.9744 120.203 83.2966 119.878 82.4302 119.878C81.4659 119.878 80.7113 120.39 80.1663 121.415C79.6212 122.427 79.3487 123.985 79.3487 126.091ZM82.4302 132.305C83.4084 132.305 84.1701 131.8 84.7151 130.788C85.2601 129.763 85.5326 128.197 85.5326 126.091C85.5326 124.304 85.3579 122.919 85.0086 121.935L80.3549 131.225C80.858 131.945 81.5498 132.305 82.4302 132.305Z",
    fill: "url(#paint46_linear_448_20)",
    fillOpacity: 0.6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_448_20",
    x1: 43.5,
    y1: 0,
    x2: 43.5,
    y2: 311.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7DD43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7DD43",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_448_20",
    x1: 43.5,
    y1: 0,
    x2: 43.5,
    y2: 311.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7DD43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7DD43",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_448_20",
    x1: 43.5,
    y1: 0,
    x2: 43.5,
    y2: 311.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7DD43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7DD43",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_448_20",
    x1: 43.5,
    y1: 0,
    x2: 43.5,
    y2: 311.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7DD43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7DD43",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_448_20",
    x1: 43.5,
    y1: 0,
    x2: 43.5,
    y2: 311.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7DD43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7DD43",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_448_20",
    x1: 43.5,
    y1: 0,
    x2: 43.5,
    y2: 311.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7DD43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7DD43",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_448_20",
    x1: 43.5,
    y1: 0,
    x2: 43.5,
    y2: 311.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7DD43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7DD43",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_448_20",
    x1: 43.5,
    y1: 0,
    x2: 43.5,
    y2: 311.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7DD43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7DD43",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_448_20",
    x1: 43.5,
    y1: 0,
    x2: 43.5,
    y2: 311.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7DD43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7DD43",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_448_20",
    x1: 43.5,
    y1: 0,
    x2: 43.5,
    y2: 311.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7DD43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7DD43",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_448_20",
    x1: 43.5,
    y1: 0,
    x2: 43.5,
    y2: 311.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7DD43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7DD43",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_448_20",
    x1: 43.5,
    y1: 0,
    x2: 43.5,
    y2: 311.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7DD43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7DD43",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_448_20",
    x1: 43.5,
    y1: 0,
    x2: 43.5,
    y2: 311.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7DD43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7DD43",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_448_20",
    x1: 43.5,
    y1: 0,
    x2: 43.5,
    y2: 311.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7DD43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7DD43",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_448_20",
    x1: 43.5,
    y1: 0,
    x2: 43.5,
    y2: 311.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7DD43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7DD43",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_448_20",
    x1: 43.5,
    y1: 0,
    x2: 43.5,
    y2: 311.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7DD43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7DD43",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_448_20",
    x1: 43.5,
    y1: 0,
    x2: 43.5,
    y2: 311.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7DD43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7DD43",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_448_20",
    x1: 43.5,
    y1: 0,
    x2: 43.5,
    y2: 311.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7DD43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7DD43",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_448_20",
    x1: 43.5,
    y1: 0,
    x2: 43.5,
    y2: 311.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7DD43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7DD43",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_448_20",
    x1: 43.5,
    y1: 0,
    x2: 43.5,
    y2: 311.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7DD43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7DD43",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_448_20",
    x1: 43.5,
    y1: 0,
    x2: 43.5,
    y2: 311.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7DD43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7DD43",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_448_20",
    x1: 43.5,
    y1: 0,
    x2: 43.5,
    y2: 311.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7DD43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7DD43",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_448_20",
    x1: 43.5,
    y1: 0,
    x2: 43.5,
    y2: 311.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7DD43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7DD43",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_448_20",
    x1: 43.5,
    y1: 0,
    x2: 43.5,
    y2: 311.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7DD43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7DD43",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_448_20",
    x1: 43.5,
    y1: 0,
    x2: 43.5,
    y2: 311.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7DD43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7DD43",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_448_20",
    x1: 43.5,
    y1: 0,
    x2: 43.5,
    y2: 311.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7DD43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7DD43",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_448_20",
    x1: 43.5,
    y1: 0,
    x2: 43.5,
    y2: 311.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7DD43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7DD43",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_448_20",
    x1: 43.5,
    y1: 0,
    x2: 43.5,
    y2: 311.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7DD43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7DD43",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_448_20",
    x1: 43.5,
    y1: 0,
    x2: 43.5,
    y2: 311.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7DD43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7DD43",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_448_20",
    x1: 43.5,
    y1: 0,
    x2: 43.5,
    y2: 311.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7DD43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7DD43",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_448_20",
    x1: 43.5,
    y1: 0,
    x2: 43.5,
    y2: 311.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7DD43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7DD43",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_448_20",
    x1: 43.5,
    y1: 0,
    x2: 43.5,
    y2: 311.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7DD43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7DD43",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_448_20",
    x1: 43.5,
    y1: 0,
    x2: 43.5,
    y2: 311.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7DD43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7DD43",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_448_20",
    x1: 43.5,
    y1: 0,
    x2: 43.5,
    y2: 311.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7DD43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7DD43",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_448_20",
    x1: 43.5,
    y1: 0,
    x2: 43.5,
    y2: 311.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7DD43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7DD43",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_448_20",
    x1: 43.5,
    y1: 0,
    x2: 43.5,
    y2: 311.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7DD43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7DD43",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_448_20",
    x1: 43.5,
    y1: 0,
    x2: 43.5,
    y2: 311.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7DD43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7DD43",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_448_20",
    x1: 43.5,
    y1: 0,
    x2: 43.5,
    y2: 311.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7DD43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7DD43",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_448_20",
    x1: 43.5,
    y1: 0,
    x2: 43.5,
    y2: 311.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7DD43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7DD43",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_448_20",
    x1: 43.5,
    y1: 0,
    x2: 43.5,
    y2: 311.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7DD43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7DD43",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_448_20",
    x1: 43.5,
    y1: 0,
    x2: 43.5,
    y2: 311.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7DD43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7DD43",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_448_20",
    x1: 43.5,
    y1: 0,
    x2: 43.5,
    y2: 311.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7DD43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7DD43",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_448_20",
    x1: 43.5,
    y1: 0,
    x2: 43.5,
    y2: 311.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7DD43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7DD43",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_448_20",
    x1: 43.5,
    y1: 0,
    x2: 43.5,
    y2: 311.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7DD43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7DD43",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_448_20",
    x1: 43.5,
    y1: 0,
    x2: 43.5,
    y2: 311.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7DD43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7DD43",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_448_20",
    x1: 43.5,
    y1: 0,
    x2: 43.5,
    y2: 311.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7DD43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7DD43",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_448_20",
    x1: 43.5,
    y1: 0,
    x2: 43.5,
    y2: 311.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7DD43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7DD43",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber);
export default __webpack_public_path__ + "static/media/number.965c9c242e5defb30ab612d452414560.svg";
export { ForwardRef as ReactComponent };